import React, { useEffect } from 'react';
import { injectGtm } from './injectGtm';
import { initClickTracking } from './clickTracking';
import { AppType, isEmittingEnvironment } from './config';
import { onIdentityResolved } from './identityReadiness';

export interface GtmProviderProps {
  app: AppType;
  distEnv?: string;
  containerId?: string;
  serverContainerUrl?: string;
  children?: React.ReactNode;
}

export const GtmProvider: React.FC<GtmProviderProps> = ({
  app,
  distEnv,
  containerId,
  serverContainerUrl,
  children,
}) => {
  useEffect(() => {
    if (!isEmittingEnvironment(distEnv)) return;

    const unsubscribe = onIdentityResolved(() => {
      if (containerId) {
        injectGtm(containerId, { serverContainerUrl });
      }
    });

    const disposeClickTracking = initClickTracking();
    return () => {
      unsubscribe();
      disposeClickTracking();
    };
  }, [app, distEnv, containerId, serverContainerUrl]);

  return <>{children}</>;
};
